module.exports = __webpack_public_path__ + "img/sky_force.763fedb5.png";